import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import ListDataOnArrivalMedical from "./ListDataOnArrivalMedical";
import { getOnarrivalmedicalData } from "../../../../store/Api";

export default function OnArrivalMedical() {
  //screen Title Show fun
  const dispatch = useDispatch();
  const titleBorder = [
    { label: "ON ARRIVAL MEDICAL", link: "/dashboard/OnArrivalMedical" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
  }, []);

  // get DAta
  const token = localStorage.getItem("nodeToken");

  const fetchOnArrivalData = useCallback(
    (page = 1, limit = 50) => {
      if (!token) return;
      dispatch(getOnarrivalmedicalData({ token, page, limit }));
    },
    [dispatch, token]
  );

  useEffect(() => {
    fetchOnArrivalData();
  }, [fetchOnArrivalData]);

  const Client = useSelector((state) => state.onArrivalData);
  const updateList = () => {
    fetchOnArrivalData(Client?.meta?.page || 1, Client?.meta?.limit || 50);
  };

  return (
    <>
      <div className={`ml-5 mr-5`}>
        <div>
          <ListDataOnArrivalMedical
            list={Client}
            titles={[
              "S.NO.",
              "point of hire",
              "EMPLOYEE ID",
              "VISA PROVIDER",
              "Client Name",
              "SPONSOR ID",
              "EMPLOYEE NAME",
              "VISA REFERENCE NUMBER",
              "VISA STAMPING DATE",
              "VISA BLOCK NUMBER",
              "BORDER NUMBER",
              "PASSPORT NUMBER",
              "Nationality",
              "Actual Profession",
              "Iqama Profession",
              " Visa / Iqama Profession (Arabic)", // Arabic(To be developed in VRF GR flow),
              "Arrival Date",
              "Date of Birth",
              "ON ARRIVAL MEDICAL APPLICATION DATE",
              "ON ARRIVAL MEDICAL STATUS",
              "ON ARRIVAL MEDICAL STATUS DATE",
              "ON ARRIVAL MEDICAL DEPENDENCY",
              "STATUS",
              "Action",
            ]}
            token={token}
            updateList={updateList}
            fetchData={fetchOnArrivalData}
          />
        </div>
      </div>
    </>
  );
}
